module.exports = {
	"name": "youtube",
	"type": "adapter",
	"tech": "js",
	"author": "Marc Maycas",
	"version": "6.0.0",
	"built": "2017-06-12",
	"repo": "https://bitbucket.org/npaw/youtube-adapter-js",
	"libVersion": "6.0.3",
	"features": {
		"buffer": "monitor",
		"seek": "monitor",
		"getters": [
			"getPlayhead",
			"getDuration",
			"getRendition",
			"getTitle",
			"getResource"
		]
	},
	"ads": []
};


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 25
// module chunks = 0